import React, { Component } from 'react';
import { Form, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import { fetchAndSetFlashMessage, Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import { cloneDeep, isEmpty } from 'lodash';
import "./index.css";
import ParameterTable from '../ParameterTable.js';
import SelectableBodyTable from "../SelectableBodyTable";
import { CopyButton } from '../../WebhooksSms/CopyButton.js';
import Marquee from 'react-fast-marquee';

function buildModalSelections() {
    const selections = {};
    ['custom', 'tts', 'sms'].forEach(prefix => {
        for (let i = 1; i <= 10; i++) {
            const key = `${prefix}_${i}`;
            selections[key] = { checked: false, parameter: key, value: key, editing: false, tempParameter: key, tempValue: key };
        }
    });
    return selections;
}

function buildModalSelectionsFromTable(bodyTable) {
    const selections = buildModalSelections();
    bodyTable.filter(r => r.custom).forEach(r => {
        const match = r.value.match(/^\{(.+)\}$/);
        if (match) {
            const key = match[1];
            if (selections[key]) {
                selections[key] = {
                    ...selections[key],
                    checked: true,
                    parameter: r.parameter,
                    tempParameter: r.parameter
                };
            }
        }
    });
    return selections;
}

class AddWebhooks extends Component {
    constructor(props) {
        super(props);
        const protocol = window.location.protocol;
        const slashes = protocol.concat("//");
        const sitePath = slashes.concat(window.location.hostname);

        this.state = {
            userId: props.app.userId,
            apiPath: props.app.apiPath,
            sitePath: sitePath,
            webhookAdded: false,
            eventList: [],
            webhookname: '',
            webhookurl: '',
            eventName: '',
            headers: { "Content-Type": "application/json" },
            bodyTable: [],
            bodyParams: {},
            bodyParamsStd: {},
            customHeaderParam: '',
            customHeaderValue: '',
            markAsDefault: 0,
            alertMessage: '',
            showSampleJson: false,
            showBodyModal: false,
            modalSelections: buildModalSelections()
        };
    }

    componentDidMount() {
        const apiPath = this.state.apiPath;

        fetchAndSetFlashMessage(
            this.props.app.apiPath,
            msg => msg.moduleName === "webhook" && msg.action === "add",
            msg => this.setState({ alertMessage: msg }),
            null,
            null,
            this.props.app.userId
        );

        Fetcher.get(apiPath + '/api/obd/webhooks/events')
            .then(res => this.setState({ eventList: res }))
            .catch(err => console.log('Error fetching Events', err));

        Fetcher.get(apiPath + '/api/obd/webhook/body/parameters')
            .then(res => {
                const table = res?.map((r, index) => {
                    return {
                        id: index + 1,
                        parameter: r.parameterName,
                        value: r.parameterName,
                        selected: true
                    }
                })
                const params = Object.fromEntries(
                    res.map(item => [item.parameterName, `{${item.parameterName}}`])
                )
                this.setState({
                    bodyParams: params,
                    bodyTable: table,
                    bodyParamsStd: params
                })
            })
            .catch(err => { console.log('Error in fetching Body Parameters', err) });

    }

    setvalue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleCheckboxChange = (e) => {
        this.setState({ markAsDefault: e.target.checked ? 1 : 0 });
    };

    handleAddWebhooks = (event) => {
        event.preventDefault();

        const data = {
            webhookName: this.state.webhookname,
            url: this.state.webhookurl,
            event: this.state.eventName,
            userId: Number(this.state.userId),
            headerJson: JSON.stringify(this.state.headers),
            bodyJson: JSON.stringify(this.state.bodyParams),
            markAsDefault: this.state.markAsDefault
        };

        return Fetcher.post(this.props.app.apiPath + '/api/obd/addWebHooks', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(res => {
                Notify.notify(res.message);
                this.setState({ webhookAdded: res.message !== 'Parameters Incorrect' });
            })
            .catch(err => {
                console.log('Error Adding webhooks', err);
                Notify.notify('Error in Adding webhooks');
            });
    };

    handleAddCustomHeaderParam = () => {
        const trimmedParam = this.state.customHeaderParam.trim();
        const { headers } = this.state;

        if (!trimmedParam) return Notify.notify("Please fill parameter name");
        if (trimmedParam.includes(" ")) return Notify.notify("Parameter name cannot contain spaces");

        const exists = Object.keys(headers).some(
            key => key.toLowerCase() === trimmedParam.toLowerCase()
        );

        if (exists) return Notify.notify("This parameter has already been added");

        const value = this.state.customHeaderValue.trim() || trimmedParam;

        this.setState({
            headers: { ...headers, [trimmedParam]: value },
            customHeaderParam: '',
            customHeaderValue: ''
        });
    };

    handleRemoveHeader = (p) => {
        const updated = { ...this.state.headers };
        delete updated[p];
        this.setState({ headers: updated });
    };

    toggleBodySelect = (id) => {
        const bodyTable = this.state.bodyTable.map(row =>
            row.id === id ? { ...row, selected: !row.selected } : row
        );

        const bodyParams = {};
        bodyTable.filter(r => r.selected).forEach(r => {
            bodyParams[r.parameter] = r.custom
                ? r.value
                : `{${r.value}}`;
        });

        this.setState({ bodyTable, bodyParams });
    };

    toggleBodySelectAll = () => {
        const allSelected = this.state.bodyTable.every(r => r.selected);

        const bodyTable = this.state.bodyTable.map(r => ({
            ...r,
            selected: !allSelected
        }));

        const bodyParams = {};
        bodyTable.filter(r => r.selected).forEach(r => {
            bodyParams[r.parameter] = r.custom
                ? r.value
                : `{${r.value}}`;
        });

        this.setState({ bodyTable, bodyParams });
    };

    editBodyParameter = (id, newName) => {
        const trimmed = newName.trim();
        if (!trimmed) return Notify.notify("Parameter cannot be empty");

        const bodyTable = this.state.bodyTable.map(r => {
            if (r.id === id) {
                return {
                    ...r,
                    parameter: trimmed,
                };
            }
            return r;
        });

        const bodyParams = {};
        bodyTable.forEach(r => {
            if (r.selected) {
                bodyParams[r.parameter] = r.custom
                    ? r.value
                    : `{${r.value}}`;
            }
        });

        this.setState({ bodyTable, bodyParams });
    };

    handleRemoveCustomParameter = (id) => {
        const bodyTable = this.state.bodyTable.filter(row => row.id !== id);

        const bodyParams = {};
        bodyTable.filter(r => r.selected).forEach(r => {
            bodyParams[r.parameter] = r.value;
        });

        this.setState({ bodyTable, bodyParams });
    };

    handleModalCheckboxChange = (key) => {
        const modalSelections = { ...this.state.modalSelections };
        const sel = modalSelections[key];

        const lastUnderscore = key.lastIndexOf('_');
        const prefix = key.substring(0, lastUnderscore);
        const index = parseInt(key.substring(lastUnderscore + 1));

        if (!sel.checked) {
            // Enforce sequential: all previous must be checked first
            for (let i = 1; i < index; i++) {
                if (!modalSelections[`${prefix}_${i}`].checked) {
                    return Notify.notify(`Please select ${prefix}_${i} first`);
                }
            }
            modalSelections[key] = { ...sel, checked: true };
        } else {
            // Uncheck this and all subsequent in the group
            for (let i = index; i <= 10; i++) {
                const k = `${prefix}_${i}`;
                modalSelections[k] = { ...modalSelections[k], checked: false, editing: false };
            }
        }

        this.setState({ modalSelections });
    };

    handleModalEditStart = (key) => {
        const modalSelections = { ...this.state.modalSelections };
        const sel = modalSelections[key];
        modalSelections[key] = { ...sel, editing: true, tempParameter: sel.parameter, tempValue: sel.value };
        this.setState({ modalSelections });
    };

    handleModalTempChange = (key, field, val) => {
        const modalSelections = { ...this.state.modalSelections };
        modalSelections[key] = { ...modalSelections[key], [field]: val };
        this.setState({ modalSelections });
    };

    handleModalEditSave = (key) => {
        const modalSelections = { ...this.state.modalSelections };
        const sel = modalSelections[key];
        const trimmedParam = sel.tempParameter.trim();

        if (!trimmedParam) return Notify.notify("Parameter cannot be empty");

        const reservedKeys = ['custom', 'tts', 'sms'].flatMap(prefix =>
            Array.from({ length: 10 }, (_, i) => `${prefix}_${i + 1}`)
        ).filter(k => k !== key);

        if (reservedKeys.includes(trimmedParam)) {
            return Notify.notify(`"${trimmedParam}" is a reserved name and cannot be used`);
        }

        modalSelections[key] = { ...sel, parameter: trimmedParam, editing: false };
        this.setState({ modalSelections });
    };

    handleModalEditCancel = (key) => {
        const modalSelections = { ...this.state.modalSelections };
        modalSelections[key] = { ...modalSelections[key], editing: false };
        this.setState({ modalSelections });
    };

    handleAddFromModal = () => {
        if (!this.state.showBodyModal) return;

        const { modalSelections, bodyTable, bodyParams } = this.state;
        const checkedEntries = Object.entries(modalSelections).filter(([, v]) => v.checked);

        if (checkedEntries.length === 0) {
            return Notify.notify("Please select at least one parameter");
        }

        let newBodyTable = [...bodyTable];
        let newBodyParams = { ...bodyParams };

        checkedEntries.forEach(([, sel]) => {
            const trimmedParam = sel.parameter.trim();
            const trimmedValue = sel.value.trim() || trimmedParam;

            if (!trimmedParam) return;

            const exists = newBodyTable.some(
                r => r.parameter.toLowerCase() === trimmedParam.toLowerCase()
            );

            if (exists) return;

            const wrappedValue = `{${trimmedValue}}`;

            const newRow = {
                id: newBodyTable.length + 1,
                parameter: trimmedParam,
                value: wrappedValue,
                selected: true,
                custom: true
            };

            newBodyTable = [...newBodyTable, newRow];
            newBodyParams[trimmedParam] = wrappedValue;
        });

        this.setState({
            bodyTable: newBodyTable,
            bodyParams: newBodyParams,
            showBodyModal: false,
            modalSelections: buildModalSelections()
        });
    };

    renderModalCheckboxGroup = (prefix, label) => {
        const { modalSelections } = this.state;
        return (
            <div className="mb-3">
                <h6 className="text-capitalize fw-bold">{label}</h6>
                {Array.from({ length: 10 }, (_, i) => {
                    const key = `${prefix}_${i + 1}`;
                    const sel = modalSelections[key];
                    return (
                        <div key={key} className="mb-2">
                            <Form.Check
                                type="checkbox"
                                id={`modal-cb-${key}`}
                                label={key}
                                checked={sel.checked}
                                onChange={() => this.handleModalCheckboxChange(key)}
                            />
                            {sel.checked && (
                                sel.editing ? (
                                    <div className="mt-1 ms-3 d-flex align-items-center gap-1 flex-nowrap">
                                        <Form.Control
                                            size="sm"
                                            style={{ width: '110px' }}
                                            placeholder="Parameter"
                                            value={sel.tempParameter}
                                            onChange={(e) =>
                                                this.handleModalTempChange(key, 'tempParameter', e.target.value)
                                            }
                                        />
                                        <small className="text-muted text-nowrap">{`{${sel.value}}`}</small>
                                        <Button
                                            variant="success"
                                            size="sm"
                                            onClick={() => this.handleModalEditSave(key)}
                                        >
                                            <i className="fa fa-check"></i>
                                        </Button>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => this.handleModalEditCancel(key)}
                                        >
                                            <i className="fa fa-times"></i>
                                        </Button>
                                    </div>
                                ) : (
                                    <div className="mt-1 ms-3 d-flex align-items-center gap-2">
                                        <small>{sel.parameter}</small>
                                        <small className="text-muted text-nowrap">{`{${sel.value}}`}</small>
                                        <Button
                                            variant="warning"
                                            size="sm"
                                            onClick={() => this.handleModalEditStart(key)}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </Button>
                                    </div>
                                )
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    render() {
        if (this.state.webhookAdded) return <Redirect to="/webhook-list" />;

        const submitButtonlabel = "Add Webhook";

        const eventList = cloneDeep(this.state.eventList);
        let eventDropdown = "";

        if (!isEmpty(eventList) && !("error" in eventList)) {
            eventDropdown = Array.isArray(eventList)
                ? eventList.map((obj, index) => (
                      <option value={obj.eventName} key={index}>
                          {obj.eventName}
                      </option>
                  ))
                : [];
        } else {
            eventDropdown = <option value="">No Event found</option>;
        }

        const hasHeaders = Object.keys(this.state.headers).length > 0;
        const hasBodyParams = this.state.bodyTable.length > 0;

        return (
            <>
            <Form className="add-campaign-form" onSubmit={this.handleAddWebhooks}>
                <Row>
                    <Col sm={12}>
                        <Card>
                            {this.state.alertMessage && <Marquee className="fade m-2 alert alert-success show">{this.state.alertMessage}</Marquee>}
                            <Card.Header>Add Webhook</Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <Form.Group>
                                            <Form.Label>Webhook Name</Form.Label>
                                            <Form.Control
                                                required
                                                name="webhookname"
                                                value={this.state.webhookname}
                                                onChange={this.setvalue}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group>
                                            <Form.Label>Webhook URL</Form.Label>
                                            <Form.Control
                                                required
                                                name="webhookurl"
                                                value={this.state.webhookurl}
                                                onChange={this.setvalue}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group>
                                            <Form.Label>Event</Form.Label>
                                            <Form.Select
                                                required
                                                name="eventName"
                                                onChange={this.setvalue}
                                            >
                                                <option value="">Select Events</option>
                                                {eventDropdown}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col sm={3} className="mt-4">
                                        <Form.Group className="mt-2">
                                            <Form.Check
                                                type="checkbox"
                                                label="Make this as default"
                                                checked={this.state.markAsDefault === 1}
                                                onChange={this.handleCheckboxChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Headers Section */}
                                <Row className="mt-4">
                                    <Col sm={12}>
                                        <h5>Headers</h5>

                                        <Row className="mt-3">
                                            <Col sm={3}>
                                                <Form.Label>Parameter</Form.Label>
                                                <Form.Control
                                                    value={this.state.customHeaderParam}
                                                    placeholder="Parameter"
                                                    onChange={(e) =>
                                                        this.setState({
                                                            customHeaderParam: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>

                                            <Col sm={3}>
                                                <Form.Label>Value</Form.Label>
                                                <Form.Control
                                                    value={this.state.customHeaderValue}
                                                    placeholder="Value"
                                                    onChange={(e) =>
                                                        this.setState({
                                                            customHeaderValue: e.target.value
                                                        })
                                                    }
                                                />
                                            </Col>

                                            <Col sm={2} className="mt-2">
                                                <Button
                                                    className='mt-4 mb-0'
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={this.handleAddCustomHeaderParam}
                                                >
                                                    <i className="fa fa-plus"></i> Add
                                                </Button>
                                            </Col>
                                        </Row>

                                        {hasHeaders && (
                                            <Row className="mt-2">
                                                <Col sm={hasHeaders ? 6 : 12}>
                                                    <ParameterTable
                                                        data={Object.keys(this.state.headers).map(
                                                            (key) => ({
                                                                parameter: key,
                                                                value: this.state.headers[key]
                                                            })
                                                        )}
                                                        onRemove={this.handleRemoveHeader}
                                                        showTable={true}
                                                    />
                                                </Col>

                                                {hasHeaders && <Col sm={4}>
                                                    <h6>Headers JSON</h6>
                                                    <pre style={{
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '10px',
                                                        borderRadius: '5px',
                                                        maxHeight: '200px',
                                                        overflow: 'auto',
                                                        fontSize: '12px',
                                                        marginTop: '10px'
                                                    }}>
                                                        {JSON.stringify(this.state.headers, null, 2)}
                                                    </pre>
                                                    <CopyButton text={this.state.headers} className='custom-copy-button'/>
                                                </Col>}
                                            </Row>
                                        )}
                                    </Col>
                                </Row>

                                {/* Body Parameters Section */}
                                <Row className="mt-4">
                                    <Col sm={12}>
                                        <h5>Body</h5>
                                        <Row className="mt-3">
                                            <Col sm={2} className="mt-2">
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={() => this.setState({ showBodyModal: true, modalSelections: buildModalSelectionsFromTable(this.state.bodyTable) })}
                                                >
                                                    <i className="fa fa-plus"></i> Add
                                                </Button>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col sm={hasBodyParams ? 6 : 12}>
                                                <SelectableBodyTable
                                                    data={this.state.bodyTable}
                                                    onToggleSelect={this.toggleBodySelect}
                                                    onToggleSelectAll={this.toggleBodySelectAll}
                                                    onEditParameter={this.editBodyParameter}
                                                    onRemoveParameter={this.handleRemoveCustomParameter}
                                                    standardParameters={Object.keys(this.state.bodyParamsStd)}
                                                />
                                            </Col>

                                            {hasBodyParams && <Col sm={4}>
                                                <h6>Selected Body JSON</h6>
                                                <pre style={{
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '10px',
                                                        borderRadius: '5px',
                                                        maxHeight: '200px',
                                                        overflow: 'auto',
                                                        fontSize: '12px',
                                                        marginTop: '10px'
                                                    }}>
                                                    {JSON.stringify(this.state.bodyParams, null, 2)}
                                                </pre>
                                                <CopyButton text={JSON.stringify(this.state.bodyParams, null, 2)} className='custom-copy-button'/>
                                            </Col>}
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mt-4">
                                    <Col sm={12}>
                                        <Button variant="primary" type="submit" disabled={!this.props.app.hasPermission('Manage Campaign.Webhook List', 'add')}>
                                            {submitButtonlabel}
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Form>

            {/* Body Parameters Modal */}
            <Modal
                show={this.state.showBodyModal}
                onHide={() => this.setState({ showBodyModal: false, modalSelections: buildModalSelections() })}
                size="xl"
                dialogClassName="webhook-param-modal"
                scrollable
            >
                <Modal.Header closeButton>
                    <Modal.Title>Select Body Parameters</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={4}>
                            {this.renderModalCheckboxGroup('custom', 'Custom')}
                        </Col>
                        <Col sm={4}>
                            {this.renderModalCheckboxGroup('tts', 'TTS')}
                        </Col>
                        <Col sm={4}>
                            {this.renderModalCheckboxGroup('sms', 'SMS')}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => this.setState({ showBodyModal: false, modalSelections: buildModalSelections() })}
                    >
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={this.handleAddFromModal}>
                        Add Parameters
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default AddWebhooks;
